import React, { useState, useEffect } from "react";
import { usePrevious } from "helpers/use-previous";

import { DEFAULT_COMPANY_DROPDOWN_OPTIONS } from "..";

import {
  EmailRecipientDetailsTable,
  FilterSection,
  ClientBrokersGroup
} from "./";

const EmailRecipientDetails = ({
  rows = [],
  filterCompany,
  onFilterCompany: handleFilterCompany,
  filterCompanies
}) => {
  const [clientViewIsVisible, setClientViewIsVisible] = useState(true);
  const [contactColumnNameTitle, setContactColumnNameTitle] = useState("Client Contact");
  const [contactColumnEmailTitle, setContactColumnEmailTitle] = useState("Contact Email");
  const [searchText, setSearchText] = useState("");
  const [selectedBrokerClientToggle, setSelectedBrokerClientToggle] = useState(ClientBrokersGroup.CLIENTS);
  const [viewableEmailRecipientData, setViewableEmailRecipientData] = useState([]);
  const [tempFilterCompanies, setTempFilterCompanies] = useState([DEFAULT_COMPANY_DROPDOWN_OPTIONS]);

  const allCompaniesViewable = filterCompany === DEFAULT_COMPANY_DROPDOWN_OPTIONS.id;
  const prevRows = usePrevious(rows);

  const filterByContactNameSearchText = ({ arr, text, isContact }) => {
    const contactFieldToFilterOn = isContact ? "contactName" : "brokerContactName";

    return arr.filter(d => {
      const searchString = text.toLowerCase();
      const nameToSearch = d.contact[contactFieldToFilterOn].toLowerCase();

      return nameToSearch.indexOf(searchString) >= 0;
    });
  };

  useEffect(() => {
    setContactColumnNameTitle(clientViewIsVisible ? "Client Contact" : "Broker Contact");
    setContactColumnEmailTitle(clientViewIsVisible ? "Contact Email" : "Broker Contact Email");
  }, [clientViewIsVisible]);

  useEffect(() => {
    setClientViewIsVisible(selectedBrokerClientToggle?.value === ClientBrokersGroup.CLIENTS.value);
  }, [selectedBrokerClientToggle]);

  useEffect(() => {
    // Placeholder for filterCompanies when real data starts coming in. 20220923 TDL
  }, [filterCompanies]);

  useEffect(() => {
    /*
     * TEMPORARILY setting filter companies as options for dropdown. This is for just seeing the table filter correctly with the sample data.
     * Won't need this UseEffect at all once we're all wired up.
     */
    if (prevRows?.length !== rows.length || prevRows === undefined) {
      const companies = rows.map(({ companyId, companyName }) => ({ id: companyId, label: companyName }));
      const uniqueCompaniesInList = companies.filter((elem, index) => companies.findIndex(obj => obj.id === elem.id) === index);
      setTempFilterCompanies([DEFAULT_COMPANY_DROPDOWN_OPTIONS, ...uniqueCompaniesInList]);
      setViewableEmailRecipientData(rows);
    }
  }, [rows]);

  useEffect(() => {
    if (allCompaniesViewable && Boolean(!searchText)) {
      setViewableEmailRecipientData(rows);
    }

    if (!allCompaniesViewable && Boolean(!searchText)) {
      const filteredRowsByCompany = rows.filter(d => d.companyId === filterCompany);
      setViewableEmailRecipientData(filteredRowsByCompany);
    }

    if (allCompaniesViewable && Boolean(searchText)) {
      const filteredRows = filterByContactNameSearchText({ arr: rows, text: searchText, isContact: clientViewIsVisible });
      setViewableEmailRecipientData(filteredRows);
    }

    if (!allCompaniesViewable && Boolean(searchText)) {
      const filteredRowsByCompany = rows.filter(d => d.companyId === filterCompany);
      const filteredBySearchText = filterByContactNameSearchText({ arr: filteredRowsByCompany, text: searchText, isContact: clientViewIsVisible });
      setViewableEmailRecipientData(filteredBySearchText);
    }
  }, [searchText, clientViewIsVisible, filterCompany, allCompaniesViewable]);

  return (
    <>
      <FilterSection
        dropdownName="edcEmailRecipientCompanyNameDropdown"
        dropdownLabel="Filter by Company"
        selectedDropdownOption={filterCompany}
        dropdownOptions={tempFilterCompanies}
        onUpdateSelectedDropdownOption={handleFilterCompany}
        searchText={searchText}
        onSearchTextUpdate={setSearchText}
        selectedBrokerClientToggle={selectedBrokerClientToggle}
        onBrokerClientToggle={setSelectedBrokerClientToggle}
      />
      <EmailRecipientDetailsTable
        clientViewIsVisible={clientViewIsVisible}
        contactColumnNameTitle={contactColumnNameTitle}
        contactColumnEmailTitle={contactColumnEmailTitle}
        emailRecipientData={viewableEmailRecipientData}
      />
    </>
  );
};

export default EmailRecipientDetails;
